import { BaseService } from 'core/services';
import { FulfillmentPasswordRouteService } from 'common/data';
import { findParams } from 'core/utils';

class FulfillmentPasswordService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FulfillmentPasswordRouteService());
	}

	changePassword = async (username, oldPassword, newPassword) => {
		const response = await this.apiClient.post(
			this.routeService.changePassword(),
			`username=${username}&newPassword=${newPassword}&password=${oldPassword}`,
			{
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			}
		);
		return response;
	};

	sendResetPasswordCode = async params => {
		const url = this.routeService.sendResetPasswordCode(params);
		const response = await this.apiClient.post(url, findParams(params));
		return response;
	};

	sendResetPasswordEmail = async params => {
		const url = this.routeService.sendResetPasswordEmail(params);
		const response = await this.apiClient.post(url, findParams(params));
		return response;
	};

	resendResetPasswordEmail = async params => {
		const url = this.routeService.resendResetPasswordEmail(params);
		const response = await this.apiClient.post(url, findParams(params));
		return response;
	};

	resetPassword = async params => {
		const url = this.routeService.resetPassword(params);
		const response = await this.apiClient.post(url, findParams(params));
		return response;
	};
}

export default FulfillmentPasswordService;
